export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/Sylndr-Swift-Logo.82be2ce8.svg","height":16,"width":50,"blurWidth":0,"blurHeight":0};